export default __webpack_public_path__ + "static/media/weather.cbc7b32c.gif";